import { render, staticRenderFns } from "./website-info-detail.vue?vue&type=template&id=d5bb147c&scoped=true&"
import script from "./website-info-detail.vue?vue&type=script&lang=js&"
export * from "./website-info-detail.vue?vue&type=script&lang=js&"
import style0 from "./website-info-detail.vue?vue&type=style&index=0&id=d5bb147c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bb147c",
  null
  
)

export default component.exports